import { isSinoMotiveOrigin } from '@/utils';
import SinoMotiveRouter from './SinoMotiveRouter';
import CassChoiceRouter from './CassChoiceRouter';

const AppRouterProvider = () => {
  return isSinoMotiveOrigin() ? <SinoMotiveRouter /> : <CassChoiceRouter />;
};

export default AppRouterProvider;
